export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
      text: 'This is a Banner',
      hasIcon: true,
      class: 'fas',
      icon: 'fa-bullhorn',
      hasCTA: true,
      ctaText: 'Learn more',
      ctaLink: '#',
      isClosable: true
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return ''
  }

  classes() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Shadow', value: 'SHADOW_MD'},
      {property: 'BannerPosition', value: 'FLOAT_BOTTOM'}
    ]
  }

  styles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #5a67d8, #5a67d8)'},
      {property:'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

  iconContainerClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Size', value: 'SIZE_MD'},
    ]
  }

  iconContainerStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #4c51bf, #4c51bf)'},
    ]
  }

  iconStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

  ctaClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
    ]
  }

  ctaStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff, #ffffff)'},
      {property:'TextColor', styleProperty: 'color', value: '#4c51bf'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles()
      },
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes()
      },
      ctaClasses: {
        desktop: this.ctaClasses(),
        tablet: this.ctaClasses(),
        phone: this.ctaClasses()
      },
      ctaStyles: {
        desktop: this.ctaStyles(),
        tablet: this.ctaStyles(),
        phone: this.ctaStyles()
      },
      iconContainerClasses: {
        desktop: this.iconContainerClasses(),
        tablet: this.iconContainerClasses(),
        phone: this.iconContainerClasses()
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles()
      },
      iconContainerStyles: {
        desktop: this.iconContainerStyles(),
        tablet: this.iconContainerStyles(),
        phone: this.iconContainerStyles()
      },
    }
  }
}
